import { render, staticRenderFns } from "./create_property.vue?vue&type=template&id=fe8ed54e"
import script from "./create_property.vue?vue&type=script&lang=js"
export * from "./create_property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports